<div class="row" id="page-title-container">
  <div class="col">
      <div class="page-header">
          <h2 id="page-title">{{title}}</h2>
      </div>
      <hr />
  </div>
</div>